
export interface ItemController {
	id:string;
	label:string;
}

export interface Category {
	id:string;
	title:string;
	description:string;
	items:ItemController[];
}

export interface TaskController {
	info:Category;
	docs:Category;
	id:Category;
	insurance:Category;
	payment:Category;
}

export const TaskControllerInstance:TaskController = {
	info: {
		id: "info",
		title: "Info",
		description: "Confirm patient information and demographics",
		items: [
			{id: "demographics", label: "Demographics"},
			{id: "contact", label: "Contact"},
			{id: "emergencyContact", label: "Emergency & care contacts"},
			{id: "responsibleParty", label: "Responsible party"},
		]
	},
	docs: {
		id: "doc",
		title: "Docs",
		description: "Acknowledgement of office policies and consents",
		items: [
			{id: "consentToTreat", label: "Consent to Treat"},
			{id: "hipaaAcknowledgement", label: "HIPAA Acknowledgement"},
			{id: "financialResponsibility", label: "Financial Responsibility"},
			{id: "assignmentOfBenefits", label: "Assignment of Benefits (AOB)"},
			{id: "authorizationToRelease", label: "Authorization to Release Information (TPO)"},
			{id: "telehealthConsent", label: "Telehealth Consent"},
			{id: "officePolicies", label: "Office Policies Agreement"}
		]
	},
	id:{
		id: "id",
		title: "ID",
		description: "Verification of patient identity",
		items: [
			{id: "captured", label: "ID captured"},
			{id: "validAndUnexpired", label: "ID  is valid and unexpired"},
			{id: "legalConfirmation", label: "Legal information confirmed"}
		]
	},
	insurance: {
		id: "insurance",
		title: "Insurance",
		description: "Verify insurance details and coverage",
		items :[
			{id:"providerVerified",label:"Insurance provider verified"},
			{id:"memberIdVerified",label:"Member ID verified"},
			{id:"primaryMemberConfirmed",label:"Primary member confirmed"},
			{id:"insuranceReviewedAndApproved",label:"Insurance reviewed and approved"},
			{id:"coverageValidated",label:"Coverage validated in EHR"},
		]
	},
	payment: {
		id: "payment",
		title: "Payment",
		description: "Review and complete required payment tasks",
		items: [
			{id: "eligibility", label: "Eligibility Check"},
			{id: "coverage", label: "Coverage Check"},
			{id: "copayDetermined", label: "Copay determined"},
			{id: "copayCollected", label: "Copay collected"},
			{id: "balanceDetermined", label: "Outstanding balance determined"},
			{id: "balanceCollected", label: "Outstanding balance collected"}
		]
	}
}
